import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DataUser, ResponseDataLogin } from '../../models/generar_pedido/DataUser';
import { EmpresaService } from '../Empresa/Empresa.service';

interface Respuesta {
  message: string;
  jwt?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})

export class LoginService {
  empresaId: number;

  constructor(private http: HttpClient, private empresaService: EmpresaService) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  login(email: string, pass: string) {
    const data = {
      empresa: this.empresaId, //environment.empresaId,
      email: email,
      password: pass,
    };
    return this.http
      .post<Respuesta>(environment.apiUrl + 'login/loginAdminKabik.php', data)
      .pipe(
        map((data) => {
          if (data.jwt) {
            console.log(jwt_decode(data.jwt));
            localStorage.setItem('KabikSession', data.jwt);
            return data;
          } else {
            return data;
          }
        })
      )
      .toPromise();
  }

  loginCliente(email: string, pass: string) {
    const data = {
      empresa: this.empresaId, //environment.empresaId,
      email,
      password: pass,
      option: 'LoginUserDevolucion',
      opcion: '1'
    };
    return this.http
      .post<Respuesta>(environment.apiUrl + 'login/loginUsuariosDevoluciones.php', data) //login para generar Guias de devolucion de articulos
      .pipe(
        map((data) => {
          if (data.jwt) {
            // console.log(data.jwt);
            localStorage.setItem('KabikSession', data.jwt);
            return data;
          } else {
            return data;
          }
        })
      )
      .toPromise();

  }

  cargarCliente(cliente: any, nombre: string, Sucursal?: string) {
    const option = 'vendedorLoadCliente';
    const data = this.getUserData();
    console.log('datosvendedor',data)
    const dataquery = {
      option,
      empresa: this.empresaId,
      cliente: btoa((JSON.stringify({ clienteID: cliente, nombre, Sucursal }))),
      vendedor: btoa((JSON.stringify({ clienteID: '2053', email: data.correo }))),
      tpLogin: 1,
      tipoLogin: 'empleado',
      uid: '',
      ipify: btoa(localStorage.getItem('ipify')),
      token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXBpLmthYmlrLm14IiwiYXVkIjoiaHR0cHM6XC9cL2FwaS5rYWJpay5teFwvIiwiaWF0IjoxNzQwNjkwNjA5LCJuYmYiOjE3NDA2OTA2MDksImV4cCI6MTc0MDcxOTQwOSwidXNlckRhdGEiOnsiY2xpZW50X251bWJlciI6IjIwNTMiLCJub21icmUiOiJLRUlUSCBJU1JBRUwgRUxJWk9ORE8gU0FOVElBR08iLCJjb21wYW55X25hbWUiOiJLRUlUSCBJU1JBRUwgRUxJWk9ORE8gU0FOVElBR08iLCJwdWVzdG8iOiJHZXJlbnRlIiwiYWxsb3dfcHJpY2VzIjoiU0kiLCJwZXJtaXNvX2VzdGFkb19jdWVudGEiOiJTSSIsInBlcm1pc29fY29tcHJhciI6IlNJIiwicGVybWlzb19hZ3JlZ2FyX2NsaWVudGVzX2ZpbmFsZXMiOiJTSSIsInBlcm1pc29fY2Fycml0b19jb21wcmFzIjoiU0kiLCJwZXJtaXNvX2ZhY3R1cmFjaW9uIjoiU0kiLCJwZXJtaXNvX2J1c2NhciI6IlNJIiwiZXNfcHVibGljb2dlbmVyYWwiOiJOTyIsImFjdGl2byI6IlNJIiwiZW1haWwiOiJpc3JhZWwuZWxpem9uZG9Aa2FiaWsuY29tLm14Iiwic3VjdXJzYWwiOiJLQUJJSyBOT1JURSIsImFsbWFjZW5QcmUiOiIxIiwiY29ycmVvVmVuZGVkb3IiOiIiLCJ1aWQiOiIiLCJhdmF0YXIiOiIiLCJwcm92aWRlSWQiOiIiLCJpZFByb2ZpbGUiOiIiLCJlbWFpbEFzc29jIjoiIiwicGxhdGZvcm0iOm51bGwsImNvcnJlb0FsbWFjZW4iOiIiLCJhbG1hY2VuZXMiOlsiMSJdLCJ0aXBvQ2FtYmlvIjoiMjAuNjM0MCIsInRpcG9JbXB1ZXN0byI6IjAuMTYiLCJoYXNQYXNzIjp0cnVlLCJ2ZW5kZWRvckxldmFudGFQZWRpZG8iOnRydWUsImxvZ0lkIjoiNDUyNzUiLCJjb3JyZW9WZW5kZWRvckxldmFudGFQZWRpZG8iOiJpc3JhZWwuZWxpem9uZG9Aa2FiaWsuY29tLm14IiwibnVtZXJvX3ZlbmRlZG9yIjoiMjA1MyIsInZlbmRlZG9yQ29ycmVvIjoiIiwidmVuZGVkb3JQdWVzdG8iOm51bGwsInZlbmRlZG9yVGVsZWZvbm8iOiIiLCJ2ZW5kZWRvck5vbWJyZSI6IkNMSUVOVEUgTlVFVk8gICIsInZlbmRlZG9yVGVsZWZvbm9TdWN1cnNhbCI6IjgzMzQ1NDM1NjAiLCJ2ZW5kZWRvclN1Y3Vyc2FsTm9tYnJlIjoiS0FCSUsgTk9SVEUiLCJ2ZW5kZWRvckZvdG8iOiJodHRwczpcL1wvYXBpLmthYmlrLm14XC9pbWFnZW5lc19wYWdpbmFcL0thYmlrXC9pbWFnZW5lc19lamVjdXRpdm9zXC8xMDcuanBnIiwicGVybWlzb19rYWJpQ29pbnMiOnRydWUsImVzX2NsaWVudGVfZmluYWwiOiJTSSJ9fQ.a9zRrZYYgafDpg7uj4VVmEMQSOj-vqYnfAFtOtjW9uNSFjnvgB_UXdkRqx21Ydu5XPx-1K-RXrbylpnfMCTyACnn9_K0apAmVLzvwwjJxKDCOUX2vFR-TsgtPPONhXxPpAi-ecuEvr_BX7yZ_n8gbJrKhEUmAt9npAl3oatiqCfxSwZ6jjrw3IZ5_uS2bO6EX6-kVVRcS7dibBePmrulXP1mlzccAiV7k5R4p-u2HZAS0kH7yAgXtgWPxfbSGDgWJ9XaGBoKUzK4_QifwcgRgukfcIPPUPzUmGZL2Q0Zi3vIn-mNjiicXu36ETVT8zohuti4sQfXdtPHrl4cWtuFJg'
    };
    console.log('datos query',dataquery)
    return this.http.post<ResponseDataLogin>(environment.apiUrl + 'login/login_KB.php', dataquery)
      .pipe(
        retry(1),
        map((res: ResponseDataLogin) => {
          if (res.message === 'true') {
            localStorage.setItem('clientePedidoSession', res.jwt);
          }
          return res;
        }));
  }

  loginClientePedidos = (cliente?: any): Observable<any> => {
    const vendedor = this.getUserData();
    const data = {
      option: 'loginClienteIntranet',
      empresa: this.empresaId,
      correo: vendedor.correo,
      password: '',
      tpLogin: 1,
      tipoLogin: 'loginCliente',
      cliente: cliente,
      uid: '',
      ipify: btoa(localStorage.getItem('ipify'))
    }
    return this.http.post<any>(environment.apiUrl + 'login/login_KB.php', data)
      .pipe(
        map((res) => {
          if (res.message == 'true') {
            localStorage.setItem('clientePedidoSession', res.jwt)
          }
          return res;
        }),
        catchError(error => {
          console.log("Error en el login", error)
          return new Observable(observer => {
            observer.next({
              error: true,
              message: error.message || 'An error occurred during login'
            });
            observer.complete();
          });
        })
      )
  }

  getDataClientePedido() {
    const dataCliente = localStorage.getItem('clientePedidoSession');
    const data = jwt_decode(dataCliente);
    //console.log("jwt cliente", data)
    return data.userData;
  }

  isLoggedClientePedido() {
    const jwt = localStorage.getItem('clientePedidoSession');
    if (jwt) {
      const decoded = jwt_decode(jwt);
      const date = new Date(0);
      date.setUTCSeconds(decoded.exp);
      return date.valueOf() > new Date().valueOf();
    } else {
      return false;
    }
  }

  public isPublicoGeneral = (): boolean => {
    const session = localStorage.getItem('clientePedidoSession');
    if (session) {
      const desCode: DataUser = jwt_decode(session);
      return desCode.es_publicogeneral === 'SI';
    }
  }

  isLogged() {
    const jwt = localStorage.getItem('KabikSession');
    if (jwt) {
      const decoded = jwt_decode(jwt);
      const date = new Date(0);
      date.setUTCSeconds(decoded.exp);
      return date.valueOf() > new Date().valueOf();
    } else {
      return false;
    }
  }

  logOut() {
    localStorage.removeItem('KabikSession');
    window.location.reload();
    return true;
  }

  getUserData() {
    const jwt = jwt_decode(localStorage.getItem('KabikSession'));
    return jwt;
  }
  getPermisos() {
    return this.getUserData().data;
  }

  getNombreVendedor() {
    return this.getUserData().NombreVendedor;
  }

  getCorreoUsuario() {
    return this.getUserData().correo;
  }
  
  getPermisoClavesGenericas() {
    const user = this.getUserData();
    if (user.clavesGenericas === '1') {
      return true;
    } else {
      return false;
    }
  }
  getPermisoReporteVentas() {
    const user = this.getUserData();
    if (user.reporte_ventas === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoImagenes() {
    const user = this.getUserData();
    // console.log(user);
    if (user.imagenes === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoImagenesArticulos() {
    const user = this.getUserData();
    // console.log(user);
    if (user.articulos_imagenes === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoOfertas() {
    const user = this.getUserData();
    // console.log(user);
    if (user.ofertas === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoAltaClientes() {
    const user = this.getUserData();
    // console.log(user);
    if (user.clientes === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoClientesNuevos() {
    const user = this.getUserData();
    // console.log(user);
    if (user.clientes_nuevos === '1' && (user.correo === 'sistemas@integradora.net' || user.correo === 'incidencias@integradora.net')) {
      return true;
    } else {
      return false;
    }
  }

  getPermisoReporteClientes() {
    const user = this.getUserData();
    if (user.reporte_clientes === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoRH() {
    const user = this.getUserData();
    if (user.recursos_humanos === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoReporteEncuesta() {
    const user = this.getUserData();
    if (user.reporte_encuesta === '1' && (user.correo === 'sistemas@integradora.net' || user.correo === 'incidencias@integradora.net')) {
      return true;
    } else {
      return false;
    }
  }

  getPermisoReporteImgSub() {
    const user = this.getUserData();
    if (user.reporte_img_subidas === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoParticipacion() {
    const user = this.getUserData();

    if (user.reporte_participacion === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoReporteAbc() {
    const user = this.getUserData();
    if (user.reporte_abc === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisosAnalisisVentas() {
    const user = this.getUserData();
    // console.log(user);

    if (user.data.REP_ANALISIS_VENTAS === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoReporteAbc2() {
    const user = this.getUserData();
    if (user.reporte_abc2 === '1') {
      return true;
    } else {
      return false;
    }
  }

  getReporteListaCliente() {
    const user = this.getUserData();
    if (user.reporte_lista_clientes === '1' && (user.correo === 'sistemas@integradora.net' || user.correo === 'incidencias@integradora.net')) {
      return true;
    } else {
      return false;
    }
  }

  getReportePedidosEspeciales() {
    const user = this.getUserData();
    if (user.reporte_pedidos_especiales === '1') {
      return true;
    } else {
      return false;
    }
  }

  getPermisoGenerarGuia() {
    const user = this.getUserData();
    // if (user.generar_guia === "1" && (user.correo === 'sistemas@integradora.net' || user.correo === 'incidencias@integradora.net')) return true;
    if (user.generar_guia === "1") return true;
    else return false;
  }

  getPermisoConsultarGuia() {
    const user = this.getUserData();
    if (user.consulta_guia === "1") return true;
    else return false;
  }

  getPermisoConsultarCobertura() {
    const user = this.getUserData();
    if (user.consulta_cobertura === "1") return true;
    else return false;
  }
  getPermisoReporteVentas2() {
    const user = this.getUserData();
    return user.reporte_ventas2 === '1' ? true : false;
  }
  getPermisoReporteVentas2Admin() {
    const user = this.getUserData();
    return user.reporte_ventas2_admin === '1' ? true : false;
  }

  getPermisoGenerarGuiaEmpresas() {
    const user = this.getUserData();
    return user.generar_guia_empresas === '1' ? true : false;
  }

  getPermisoGenerarGuiaGarantias() {
    const user = this.getUserData();
    return user.generar_guia_garantias === '1' ? true : false;
  }

  getPermisoCatalogoDirecciones() {
    const user = this.getUserData();
    return user.catologo_direcciones === '1' ? true : false;
  }

  getPermisoSurtimientoMercancia() {
    const user = this.getUserData();
    return true;
    return user.surtimiento_mercancia === '1' ? true : false;
  }

  getPermisoDepartamentosWeb() {
    const user = this.getUserData();
    return user.departamentos_web === '1' ? true : false;
  }

  getPermisoMarcasWeb() {
    const user = this.getUserData();
    return user.marcas_web === '1' ? true : false;
  }
  getPermisoArticulosWeb() {
    const user = this.getUserData();
    return user.articulos_web === '1' ? true : false;
  }

  getPermisoGruposWeb() {
    const user = this.getUserData();
    return user.grupos_web === '1' ? true : false;
  }

  getReporteCanjesKabiCoins() {
    const user = this.getUserData();
    return user.reporte_kabikcoins === '1' ? true : false;
  }


  getetPermisoListaPrecios() {
    const user = this.getUserData();
    return user.lista_precios === '1' ? true : false;
  }

  getArticulosProduccion() {
    const user = this.getUserData();
    return user.articulos_produccion === '1' ? true : false;
  }
  getClientesKabiCoins() {
    const user = this.getUserData();
    return user.clientes_kbcoins === '1' ? true : false;
  }
  getVentasMarcas() {
    const user = this.getUserData();
    return user.reporte_ventas_marca_vendedor === '1' ? true : false;
  }

  getPermisosBackorder() {
    const user = this.getUserData();
    return user.backorder === '1' ? true : false;
  }

  getPermisosArticulosInsumos() {
    const user = this.getUserData();
    return user.articulos_insumos === '1' ? true : false;
  }

  getPermisosProgramacionPagos() {
    const user = this.getUserData();
    return user.programacion_pagos === '1' ? true : false;
  }

  getPermisosUsuarios() {
    const user = this.getUserData();
    return user.programacion_pagos === '1' ? true : false;
  }

  getPermisoDepWebMulti() {
    const user = this.getUserData();
    return user.departamento_web_multi === '1' ? true : false;
  }

  getPermisoGrupoWebMulti() {
    const user = this.getUserData();
    return user.grupo_web_multi === '1' ? true : false;
  }

  getPermisoMarcasWebMulti() {
    const user = this.getUserData();
    return user.marcas_web_multi === '1' ? true : false;
  }

  getPermisoMargenVenMult() {
    const user = this.getUserData();
    return user.margen_vent_dep === '1' ? true : false;
  }

  getPermisoMargenMarcasMult() {
    const user = this.getUserData();
    return user.margen_vent_marcas === '1' ? true : false;
  }

  getPermisoSeguimientoPedidos() {
    const user = this.getUserData();
    return user.seguimiento_pedidos === '1' ? true : false;
  }

  getPermisosTablaPedidosMul() {
    const user = this.getUserData();
    return user.permisos_seguimiento_pedidos === '1' ? true : false;
  }

  getLicenciasZafiro() {
    const user = this.getUserData();
    return user.licencias_zafiro === '1' ? true : false;
  }

  getPermisoFirma() {
    const user = this.getUserData();
    return user.permiso_firma === '1' ? true : false;
  }

  getPermisoInventario() {
    const user = this.getUserData();
    return user.permiso_periodos_inventario === '1' ? true : false;
  }
  getPermisoRepEdoCuenta() {
    const user = this.getUserData();
    return user.rep_edo_cuenta === '1' ? true : false;
  }
  getArticulosWeb() {
    const user = this.getUserData();
    return user.articulos_web === '1' ? true : false;
  }
  getMarcasWeb() {
    const user = this.getUserData();
    return user.marcas_web === '1' ? true : false;
  }
  getDeparamentosWeb() {
    const user = this.getUserData();
    return user.departamentos_web === '1' ? true : false;
  }
  getGruposWeb() {
    const user = this.getUserData();
    return user.grupos_web === '1' ? true : false;
  }
  getResumenCosteo() {
    const user = this.getUserData();
    return user.rep_resumen_costeo === '1' ? true : false;
  }
  getPermisoEditarInsumo() {
    const user = this.getUserData();
    return user.permiso_editar_insumos === '1' ? true : false;
  }
  getArticulosUPC() {
    const user = this.getUserData();
    return user.almacen_articulos_upc === '1' ? true : false;
  }

  getAlmacenDevoluciones() {
    const user = this.getUserData();
    return user.almacen_devoluciones === '1' ? true : false;
  }
  getReporteVentasMesPorCliente() {
    const user = this.getUserData();
    return user.reporte_ventas_cliente_por_mes === '1' ? true : false;

  }
  getClintesCondionados() {
    const user = this.getUserData();
    return user.clientes_condicionados === '1' ? true : false;

  }
  getPermisoSeguimientoPedidosInventario() {
    const user = this.getUserData();
    return user.seguimiento_pedidos_inventario === '1' ? true : false;
  }
  getReporteMatriz() {
    const user = this.getUserData();
    return user.reporte_matriz === '1' ? true : false;
  }

  getReporteOts() {
    const user = this.getUserData();
    return user.garantias === '1' ? true : false;
  }

  getVentasPedidos() {
    const user = this.getUserData();
    if (user.genera_pedido === '1' && (user.correo === 'sistemas@integradora.net' || user.correo === 'incidencias@integradora.net')) {
      return true;
    } else {
      return false;
    }
    // return user.genera_pedido === '1' ? true : false;
  }

  getGeneraAccesos() {
    const user = this.getUserData();
    return user.GENERA_ACCESOS === '1'  ? true : false;
  }

  getDescargaApp() {
    const user = this.getUserData();
    return user.permiso_app_inventario === '1' ? true : false;
  }

  getPermisoPreciosMultiInventario() {
    const user = this.getUserData();
    return user.REPORTE_PRECIOS_INVENTARIOS === '1' ? true : false;
  }
}
